// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lkwxw","content":"styles_content__XDhkB","tableWrap":"styles_tableWrap__2w1ok"};